exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".already-paid-page-content {\r\n    margin-top: 75px;\r\n    min-height: calc(100vh - 440px);\r\n}\r\n", ""]);

// exports
